// extracted by mini-css-extract-plugin
export default {"iconWrapper":"_1af0R","icon":"_2fM7R"};